import React from "react";
import { Link } from "react-router-dom";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";

export const Logos = () => {
	const footerTexts = useTranslationsById({ mainSectionName: "footer" });

	return (
		<div className="logos">
			<section className="w-100 d-flex align-items-center justify-content-center my-3">
				<Link className="focusable-secondary" aria-label="MakeMake home, link" to="/">
					<img className="makemake-logo" src="/img/footer/makemake-logo.png" alt="makemake logo" />
				</Link>
				<p className="px-3" style={{ minWidth: 120 }}>
					{footerTexts.getText({ id: "product_of.part1", defaultText: "MakeMake es" })}
					<br />{" "}
					{footerTexts.getText({ id: "product_of.part2", defaultText: "un producto de" })}
					<br />{" "}
					<a
						className="focusable-secondary"
						aria-label="Makina Editorial, link."
						href="https://makinaeditorial.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						Mákina Editorial SAS
					</a>
				</p>
			</section>
		</div>
	);
};
